'use client';
import React from 'react';
import { Img } from '@/components/common/ui/images/Img';
import Link from 'next/link';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import { StyledMap } from '@/components/common/ygen/sections/map/map.style';

const Map = ({ data }) => {

	const bannerImge = data?.images?.list?.find((f) => f?.banner === 'on');
	const offset= useContainerOffset('.container')

	return (
		<StyledMap className="map" data-scroll-section offset={offset}>
			<div className="image-wrapper-map " >
				<Link prefetch={true} target={'_blank'} href={bannerImge?.short_desc}>
					<Img banner={true} alt={bannerImge?.short_title} src={data?.images ? bannerImge?.full_path : ''} />
				</Link>
			</div>

		</StyledMap>
	);
};


export default React.memo(Map);
